import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import svg from 'shared/assets/icons/sprites/articleLeasing.svg';

import s from './LeasingWhyAbUa.css';

const Icon = params =>
  <svg width="24" height="24">
    <use xlinkHref={`${svg}#${params.name}`} />
  </svg>;

const items = [
  {
    icon: 'car',
    text: 'Авто любого года выпуска и модели',
  },
  {
    icon: 'savemoney',
    text: 'Любая сумма финансирования',
  },
  {
    icon: 'buiseness',
    text: 'Без поручителей и без справки о доходах',
  },
  {
    icon: 'time',
    text: 'Автолизинг за 24 часа',
  },
  {
    icon: 'shield',
    text: 'Страховка и автогражданка оплачивается лизинговой компанией',
  },
  {
    icon: 'math',
    text: 'Отсутстве комиссий и скрытых платежей',
  },
];
class LeasingWhyAbUa extends React.Component {
  renderItem = (icon, text) =>
    <div className={s.item} key={text}>
      <div className={s.icon}>
        <Icon name={icon} />
      </div>
      <div className={s.text}>
        <FormattedMessage id={text} />
      </div>
    </div>;

  render() {
    return (
      <div className={s.root}>
        {items.map(item => this.renderItem(item.icon, item.text))}
      </div>
    );
  }
}

export default withStyles(s)(LeasingWhyAbUa);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingWhyAbUa/LeasingWhyAbUa.js